import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { APPLE_PAY } from '../../../constants/paymentMethods';

import {
    validateMerchantSession,
    authorizePayment,
    createOrder
} from '../../../services/applepay/utils';

import SvgComponent from '../../SvgComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

const ApplePayButton = ({
    userInfo,
    partnerId,
    cartTotalValue,
    label,
    token,
    ebon,
    ebonPaymentConfig,
    paymentMethods
}) => {
    const [loading, setLoading] = useState(true);
    const [canMakePayments, setCanMakePayments] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const applePayAllowed = ebonPaymentConfig.applePayAllowed && paymentMethods.includes(APPLE_PAY);
    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    useEffect(() => {
        const checkApplePayAvailability = async () => {
            if (window.ApplePaySession && window.ApplePaySession.canMakePayments) {
                try {
                    const isAvailable = await window.ApplePaySession.canMakePayments();
                    setCanMakePayments(isAvailable);
                } catch (error) {
                    console.error('Error while verifying if Apple Pay is available :', error);
                    setCanMakePayments(false);
                }
            }
            setLoading(false);
        };

        checkApplePayAvailability();
    }, []);

    const processApplePayment = async () => {
        if (window.ApplePaySession) {
            setDisabled(true);

            const session = new window.ApplePaySession(6, {
                countryCode: 'FR',
                currencyCode: 'EUR',
                merchantCapabilities: ['supports3DS'],
                supportedNetworks: ['visa', 'masterCard'],
                total: {
                    label: label,
                    type: 'final',
                    amount: cartTotalValue.toString()
                }
            });

            session.onvalidatemerchant = async event => {
                try {
                    const merchantSession = await validateMerchantSession(
                        token,
                        event.validationURL
                    );
                    if (!merchantSession) {
                        console.error('Invalid Apple Pay merchant session');
                    }
                    session.completeMerchantValidation(merchantSession);
                } catch (error) {
                    setDisabled(false);
                    console.error('merchant validation error : ', error);
                    session.abort();
                }
            };
            session.onpaymentauthorized = async event => {
                try {
                    const order = await createOrder(
                        token,
                        partnerId,
                        userInfo.phoneNumber,
                        !hasFreeFacial
                    );

                    try {
                        const link = await authorizePayment(
                            token,
                            event.payment.token,
                            userInfo,
                            partnerId,
                            order.id
                        );
                        window.location.href = link;
                    } catch (error) {
                        setDisabled(false);
                        console.error('Apple Payment authorization error : ', error);
                        const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${order.id}`;
                        window.location.href = errorUrl;
                    }
                } catch (error) {
                    setDisabled(false);
                    console.error('Error while creating order');
                    const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error`;
                    window.location.href = errorUrl;
                }
            };
            session.oncancel = event => {
                setDisabled(false);
                console.log('Apple Pay cancel event : ', event);
            };
            session.begin();
        }
    };

    return (
        <React.Fragment>
            {loading && <LoadingComponent />}

            {!loading && applePayAllowed && canMakePayments && (
                <button
                    className="applePayButtonWrapper"
                    onClick={processApplePayment}
                    disabled={disabled}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/payment/apple-pay-logo.svg`}
                        width={56}
                        height={23}
                    />
                </button>
            )}
        </React.Fragment>
    );
};

ApplePayButton.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        label: state.i18n.common.EBON,
        token: state.authentication.token,
        ebon: state.ebon,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || []
    };
};

export default connect(mapStateToProps)(ApplePayButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ApplePayButton.js